import { ROUTE_NAMES } from './routes';

export function getPrevPath(search: string) {
  let prevPath = ROUTE_NAMES.DASHBOARD;

  if (typeof window !== 'undefined') {
    const urlSearchParams = new URLSearchParams(search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (params['ref']) prevPath = params['ref'];
  }

  return prevPath;
}
